import { CandidatePriority } from '../candidate/candidate-priority';

export type NewsletterConfiguration = {
  activeState: boolean;
  autoApproved: boolean;
  firstPublishDate: Date | null;
  publishCycleInDays: number;
  publishTime: string;
  batchLimit: number;
  dailyLimit: number;
  totalArticles: number;
  featuredArticlesConfig: {
    category: string;
    count: number;
  }[];
  recentEditionsLookBack: number;
};

export const DEFAULT_NEWSLETTER_CONFIGURATION: NewsletterConfiguration = {
  activeState: false,
  autoApproved: false,
  firstPublishDate: null,
  publishCycleInDays: 42,
  publishTime: '08:30',
  batchLimit: 1000,
  dailyLimit: 10000,
  totalArticles: 5,
  featuredArticlesConfig: [{ category: 'news-und-politik', count: 2 }],
  recentEditionsLookBack: 3,
};

/**
 * Days between editor and publisher jobs executions.
 */
export const EDITOR_REVIEW_BUFFER_DAYS = 1;
/**
 * Hours between publisher processing time and email dispatch.
 */
export const PUBLISHER_SPAWN_BUFFER_HOURS = 6;

export const DATE_STYLE = { dateStyle: 'full', timeStyle: 'short' } as const;

export const MAX_RETRIES_FOR_NEW_ARTICLES = 3;

export const NEWSLETTER_HQ_CANDIDATE_PRIORITIES: CandidatePriority[] = [
  CandidatePriority.A,
  CandidatePriority.B1,
  CandidatePriority.B2,
  CandidatePriority.B3,
  CandidatePriority.B4,
  CandidatePriority.B5,
  CandidatePriority.B6,
  CandidatePriority.D1,
];
